import {applyDefaultOptions} from "../DefaultOptionsMapper";
import {applyDefaultStyle} from "../DefaultStyleMapper";
import {
    FloatingWidgetConfigurationInput,
    FloatingWidgetType
} from "../../../../Contracts/WidgetTypes/FloatingWidgetType";
import {Locale,} from "../../../../Constants/locales";
import {stringToLocale} from "../LocaleMapper";
import {fromInputWidgetThemeToWidgetTheme} from "../BaseWidgetConfigurationMapper";
import {applyInventoryAccess} from "../InventoryAccessMapper";
import {applyDisplaySettings} from "../DisplaySettingsMapper";

export default (config: FloatingWidgetConfigurationInput, instanceId: string):FloatingWidgetType => {
    return {
        ...config,
        instanceId,
        options: applyDefaultOptions(config.options ?? {}),
        displaySettings: applyDisplaySettings(config.displaySettings),
        trigger: !(config.trigger instanceof HTMLElement || Array.isArray(config.trigger)) ? applyDefaultStyle(config.trigger ?? {}) : config.trigger as HTMLElement[],
        experiencesForVouchers: config.experiencesForVouchers ?? [],
        experiencesForTickets: config.experiencesForTickets ?? [],
        flexOffers: config.flexOffers ?? [],
        inventoryAccess: applyInventoryAccess(config.inventoryAccess, {
            experiences: [...(config.experiencesForVouchers ?? []), ...(config.experiencesForTickets ?? [])],
            flexOffers: config.flexOffers ?? [],
        }),
        experiencesSortOrder: config.experiencesSortOrder ?? [],
        localisation: config?.localisation ?? {} as Record<Locale, Record<string, string>>,
        locale: config.locale ? config.locale : stringToLocale(window.navigator.language),
        checkoutTheme: config.checkoutTheme ?? 'light',
        themeConfiguration: fromInputWidgetThemeToWidgetTheme(config.themeConfiguration),
        openOnLoad: config.openOnLoad ?? false,
        chatBotProvider: config.chatBotProvider,
        webshopVisibility: config.webshopVisibility ?? true,
    }
}
